import {useRef} from "react";
import {Button, DialogActions, DialogContent, Grid} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import Call from "../../hocs/call";
import FeatureGuard from "../../hocs/feature-guard";
import FullscreenDialog from "../fullscreen-dialog";
import AiSettingsForm from "./AiSettingsForm";
import {
  fetchNodeAiSettings,
  hideNodeAISettingsModal,
  showSearchEngineListModal,
  submitNodeAiSettings
} from "../../state/ai-assistant/aiAssistantAction";
import {aiNodeSettingsSelector} from "../../state/ai-assistant/aiAssistantSelector";
import {LICENSE_FEATURES_AI} from "../../state/app/contants";
import {externalServicesSelector} from "../../state/config/configSelectors";

const AiSettingsDialog = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const baseUrl = useSelector(externalServicesSelector)?.ai;
  const {isNodeAISettingsModalVisible, nodeId, aiSettings, authToken} = useSelector(aiNodeSettingsSelector);

  const formRef = useRef();

  const getAiSettings = ({nodeId, baseUrl}) => dispatch(fetchNodeAiSettings(nodeId, baseUrl, authToken));

  const handleAiSettingsSubmit = formData => {
    const settings = Object.fromEntries(Object.entries(formData).filter(([_, value]) => value.engineId > 0));
    dispatch(submitNodeAiSettings(nodeId, settings, baseUrl, authToken));
  };

  return (
    <FeatureGuard featureKey={LICENSE_FEATURES_AI}>
      <FullscreenDialog
        title={t("modules.aiAssistant.aiSettings.dialog.title")}
        open={isNodeAISettingsModalVisible}
        onClose={() => dispatch(hideNodeAISettingsModal())}
        onSubmit={() => formRef.current?.submit()}
      >
        <DialogContent>
          <Call cb={getAiSettings} cbParam={{nodeId, baseUrl}} disabled={!nodeId || aiSettings}>
            {aiSettings && <AiSettingsForm ref={formRef} initialData={aiSettings} onSubmit={handleAiSettingsSubmit} />}
          </Call>
        </DialogContent>
        <DialogActions className="components__dialog__actions">
          <Grid container justifyContent="space-between">
            <Grid>
              <Button
                className="components__dialog__btn components__dialog__btn--cancel"
                onClick={() => dispatch(showSearchEngineListModal())}
              >
                {t("modules.aiAssistant.aiSettings.dialog.actions.showEngineList")}
              </Button>
            </Grid>
            <Grid>
              <Button
                className="components__dialog__btn components__dialog__btn--cancel"
                onClick={() => dispatch(hideNodeAISettingsModal())}
              >
                {t("commons.confirm.cancel")}
              </Button>
              <Button
                className="components__dialog__btn components__dialog__btn--submit"
                onClick={() => formRef.current?.submit()}
              >
                {t("commons.confirm.submit")}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </FullscreenDialog>
    </FeatureGuard>
  );
};

export default AiSettingsDialog;
